import bracelet1 from './Images/bracelet1.png'
import bracelet2 from './Images/bracelet2.png'
import bracelet3 from './Images/bracelet3.png'
import bracelet4 from './Images/bracelet4.png'
import bracelet5 from './Images/bracelet5.png'
import bracelet6 from './Images/bracelet6.png'
import bracelet7 from './Images/bracelet7.png'
import bracelet8 from './Images/bracelet8.png'
import bracelet9 from './Images/bracelet9.png'
import bracelet10 from './Images/bracelet10.png'
import bracelet11 from './Images/bracelet11.png'
import bracelet12 from './Images/bracelet12.png'
import bracelet13 from './Images/bracelet13.png'
import bracelet14 from './Images/bracelet14.png'
import bracelet15 from './Images/bracelet15.png'
import bracelet16 from './Images/bracelet16.png'
import bracelet17 from './Images/bracelet17.png'
import bracelet18 from './Images/bracelet18.png'
import bracelet19 from './Images/bracelet19.png'
import bracelet20 from './Images/bracelet20.png'
import bracelet21 from './Images/bracelet21.png'



const BraceletDet = [
    {
        id: 1,
        name: "Clara Anti-Tarnish 92.5 Sterling Silver Bracelet 8 inch",
        brand: "Clara",
        price: 2899,
        image: bracelet1,
        size: "8 inches"
    },
    {
        id: 2,
        name: "Black Base Metal Leather Funky Multistrand Guitar Charm Bracelet for Men",
        brand: "University Trendz",
        price: 219,
        image: bracelet2,
        size: "Regular"
    },
    {
        id: 3,
        name: "Leather with Stainless Steel Magnetic Clasp Blue Bracelet for Men",
        brand: "Moneekar Jewels",
        price: 649,
        image: bracelet3,
        size: "8.5 inch"
    },
    {
        id: 4,
        name: "Gift Natural Gemstone Crystal Beads Buddha Bracelet.",
        brand: "Young & Forever ",
        price: 420,
        image: bracelet4,
        size: "6 inches"
    },
    {
        id: 5,
        name: "Valentine Gift Rose Gold Plated Pink Flowers Bracelet",
        brand: "Om Jewells",
        price: 189,
        image: bracelet5,
        size: "Adjustable"
    },
    {
        id: 6,
        name: "Swiss Zirconia Sterling Silver Grazia Solitaire Bracelet Gift For Women",
        brand: "Clara",
        price: 1999,
        image: bracelet6,
        size: "7.5 inches"
    },
    {
        id: 7,
        name: "Silver 100% Stainless Steel 14mm Thick Link Chain Bracelet for men",
        brand: "Aaishwarya",
        price: 1017,
        image: bracelet7,
        size: "Regular"
    },
    {
        id: 8,
        name: "Men's Bracelet Genuine Leather Brown Black",
        brand: "Moneekar Jewels",
        price: 899,
        image: bracelet8,
        size: "7.5 inches"
    },
    {
        id: 9,
        name: "Rudraksha Kadas American Diamond Gold Meena Bracelets",
        brand: "MIAMI",
        price: 249,
        image: bracelet9,
        size: "Regular"
    },
    {
        id: 10,
        name: "Gold Plated Twist & Shine Bracelet o fAlloy With Crystal For Women",
        brand: "Mahi",
        price: 298,
        image: bracelet10,
        size: "Regular"
    },
    {
        id: 11,
        name: "Oviya Magical Love Tripple Heart Bracelet with Crystal Stones",
        brand: "Oviya",
        price: 199,
        image: bracelet11,
        size: "Adjustable"
    },
    {
        id: 12,
        name: "7 Chakra Certified Natural Stones 8-9mm Crystal Beads Multicolor Bracelet",
        brand: "Young & Forever ",
        price: 399,
        image: bracelet12,
        size: "One size"
    },
    {
        id: 13,
        name: "University Trendz PU Leather Bracelet For Mens & Boys",
        brand: "University Trendz",
        price: 200,
        image: bracelet13,
        size: "8.2 inches"
    },
    {
        id: 14,
        name: "Moneekar Jewels Metal Stainless Steel Bracelet for Men",
        brand: "Moneekar Jewels",
        price: 499,
        image: bracelet14,
        size: "8.5 inches"
    },
    {
        id: 15,
        name: "Silverwala Men's Silver Rubber Kada (Silver, Black)",
        brand: "Silverwala",
        price: 1060,
        image: bracelet15,
        size: "Free size"
    },
    {
        id: 16,
        name: "Lava Rock 7 Chakras Aromatherapy Essential Oil Diffuser Bracelet Bangle",
        brand: "Doitory Hamoery ",
        price: 349,
        image: bracelet16,
        size: "One size"
    },
    {
        id: 17,
        name: "Reiki Crystal Products Rose Quartz Heart, Floral Bracelet for Unisex Adult(Pink)",
        brand: "Reiki Crystal",
        price: 284,
        image: bracelet17,
        size: "Regular"
    },
    {
        id: 18,
        name: "Swiss Zirconia 925 Sterling Silver Sandra Solitaire Bracelet for Women and Girls",
        brand: "Clara",
        price: 2729,
        image: bracelet18,
        size: "7.5 inches"
    },
    {
        id: 19,
        name: "Metal & Stainless Steel Cubic Zirconia Bracelet for Men (Golden)",
        brand: "Moneekar Jewels ",
        price: 1999,
        image: bracelet19,
        size: "Regular"
    },
    {
        id: 20,
        name: "University Trendz Leather Bracelet for Men",
        brand: "University Trendz",
        price: 159,
        image: bracelet20,
        size: "Free size"
    },
    {
        id: 21,
        name: "Metal Stainless Steel Bracelet for Mens",
        brand: "Moneekar Jewels ",
        price: 449,
        image: bracelet21,
        size: "2.8"
    },
]
export default BraceletDet